import { render, staticRenderFns } from "./AssignTeamToTmpl.vue?vue&type=template&id=0356d3ce&scoped=true"
import script from "./AssignTeamToTmpl.vue?vue&type=script&lang=js"
export * from "./AssignTeamToTmpl.vue?vue&type=script&lang=js"
import style0 from "./AssignTeamToTmpl.vue?vue&type=style&index=0&id=0356d3ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0356d3ce",
  null
  
)

export default component.exports